<template>
  <div class="commerce">
    <div class="click_num">页面点击数：{{clickNum}}</div>
    <div class="title">
      <div class="title_icon">
        <img src="../../../assets/img/commerce_icon.svg" alt="">
      </div>
      <div class="title_text">产品详情</div>
    </div>
    <div class="content">
      <img src="../../../assets/img/commerce1.png" alt="">
      <img src="../../../assets/img/commerce2.png" alt="">
      <img src="../../../assets/img/commerce3.png" alt="">
      <img src="../../../assets/img/commerce4.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      clickNum: 0,
    }
  },
  watch: {
    $route: {
      handler(newVal, odlVal) {
        if (newVal.path === "/loan-commerce") {
          this.getInfo()
        } 
      },
      deep: true,
      immediate: true,
    },
  },
  created(){
    // this.getInfo()
  },
  methods: {
    getInfo(){
      this.$http.get('system/home/selfInnovateMenuClick').then(res=>{
        if(res.data.code != 0){
          return this.$message.error(res.data.msg)
        }
        console.log(333,res);
        this.clickNum = res.data.data
      })
    }
  }
}

</script>
<style lang="scss" scoped>
.commerce{
  position: relative;
  padding: 30px;
  .click_num{
    position: absolute;
    right: 16px;
    top: 16px;
  }
  .title{
    display: flex;
    align-items: center;
    border-bottom: 2px solid  rgba(214, 1, 15, 0.34);
    width: 100px;
    padding-bottom: 6px;
    .title_text{
      font-weight: bold;
      font-size: 18px;
      margin-left: 4px;
    }
  }
  .content{
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    img{
      width: 47%;
      min-width: 600px;
      margin-top: 20px ;
    }
  }
}
</style>